import { render, staticRenderFns } from "./148.vue?vue&type=template&id=810475bc&scoped=true&"
import script from "./148.vue?vue&type=script&lang=js&"
export * from "./148.vue?vue&type=script&lang=js&"
import style0 from "./148.vue?vue&type=style&index=0&id=810475bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "810475bc",
  null
  
)

export default component.exports